module.exports = {"attributes":{"viewBox":"0 0 12 11"},"content":"<path fill=\"#0F88EB\" fill-rule=\"evenodd\" d=\"M0 1.5c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5H.5C.2 0 0 .2 0 .5v1zm0 3c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5H.5c-.3 0-.5.2-.5.5v1zm0 3c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5H.5c-.3 0-.5.2-.5.5v1zm0 3c0 .3.2.5.5.5h7c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5h-7c-.3 0-.5.2-.5.5v1z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-introduce.svg
// module id = 624
// module chunks = 0